import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';
import styled from '@emotion/styled';

import { Partner } from '../../templates/partners';
import { Logo } from '../home/section-styles';
import theme from '../../theme';

interface PartnerHeadingProps {
  additionalStyles: string;
}

const TechLogoWrapper = styled.div`
  @media (max-width: ${theme.screenLgMax}) {
    margin-bottom: 48px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
`;

const TechLink = styled(Link)`
  display: inline-block;
`;

const PartnersHeading = styled.p<PartnerHeadingProps>`
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
  ${props => props.additionalStyles};
`;

const PartnersContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  > *:not(:last-child) {
    margin-right: 16px;
  }
`;

export default function TechnologyPartners({ headingStyles: headingColor }: { headingStyles: string }) {
  const data: { technologyPartners: { nodes: Partner[] } } = useStaticQuery(graphql`
    query TechnologyPartnersQuery {
      technologyPartners: allDirectusPartner(
        filter: { technology_partner: { eq: true } }
        sort: { fields: [technology_partner_sort] }
      ) {
        nodes {
          directusId
          partner_logo {
            data {
              full_url
            }
          }
          partner_slug
          partner_title
          partner_cta_label
          display_partner_page
        }
      }
    }
  `);

  const technologyPartners = data?.technologyPartners?.nodes;

  if (!technologyPartners || technologyPartners.length <= 0) return null;

  return (
    <div>
      <PartnersHeading additionalStyles={headingColor}>
        Technology Partner{technologyPartners.length > 1 ? 's' : ''}
      </PartnersHeading>
      <PartnersContent>
        {technologyPartners.slice(0, 4).map(partner => {
          return (
            <TechLogoWrapper key={partner.directusId} title={partner.partner_title}>
              <TechLink
                to={partner.partner_slug || '/'}
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore -- disabled is available on Link, but is not recognized
                disabled={!partner.display_partner_page}
              >
                <Logo src={partner.partner_logo.data.full_url} alt={partner.partner_title} />
              </TechLink>
            </TechLogoWrapper>
          );
        })}
      </PartnersContent>
    </div>
  );
}
